import { memo } from 'react'
import { css, Global } from '@emotion/react'

import RegularTtf from './regular.ttf'
import RegularWoff from './regular.woff'
import RegularWoff2 from './regular.woff2'
import LightTtf from './light.ttf'
import LightWoff from './light.woff'
import LightWoff2 from './light.woff2'
import MediumTtf from './medium.ttf'
import MediumWoff from './medium.woff'
import MediumWoff2 from './medium.woff2'
import BoldTtf from './bold.ttf'
import BoldWoff from './bold.woff'
import BoldWoff2 from './bold.woff2'

const FontFace = memo(() => (
  <Global
    styles={css`
    @font-face {
      font-family: Barlow;
      src: 
        url(${RegularTtf}) format('ttf'),
        url(${RegularWoff}) format('woff'),
        url(${RegularWoff2}) format('woff2');
    }
  
    @font-face {
      font-family: Barlow;
      font-weight: 300;
      src: 
        url(${LightTtf}) format('ttf'),
        url(${LightWoff}) format('woff'),
        url(${LightWoff2}) format('woff2');
    }
  
    @font-face {
      font-family: Barlow;
      font-weight: 500;
      src: 
        url(${MediumTtf}) format('ttf'),
        url(${MediumWoff}) format('woff'),
        url(${MediumWoff2}) format('woff2');
    }
  
    @font-face {
      font-family: Barlow;
      font-weight: 700;
      src: 
        url(${BoldTtf}) format('ttf'),
        url(${BoldWoff}) format('woff'),
        url(${BoldWoff2}) format('woff2');
    }
  `}
  />
))

// eslint-disable-next-line import/no-default-export
export default FontFace
